import Tab from '@/types/Tab'

export default function (id, listingSuffix) {
	return [
		new Tab('realtors', {
			to: { name: 'market-realtors' },
			name: 'Realtors',
			value: `/markets/${id}/realtors`,
		}),
		new Tab('cities', {
			to: { name: 'market-cities' },
			name: 'Cities',
			value: `/markets/${id}/cities`,
		}),
		new Tab('areas', {
			to: { name: 'market-areas' },
			name: 'Areas',
			value: `/markets/${id}/areas`,
		}),
		new Tab('complexes', {
			to: { name: 'market-complexes' },
			name: 'Complexes',
			value: `/markets/${id}/complexes`,
		}),
		new Tab('crawlers', {
			to: { name: 'market-crawlers' },
			name: 'Crawlers',
			value: `/markets/${id}/crawlers`,
		}),
		new Tab('listings', {
			to: listingSuffix
				? { name: `market-listings-${listingSuffix}` }
				: { name: 'market-listings' },
			name: 'Listings',
			value: listingSuffix
				? `/markets/${id}/listings/${listingSuffix}`
				: `/markets/${id}/listings`,
		}),
		new Tab('participants', {
			to: { name: 'market-participants' },
			name: 'Participants',
			value: `/markets/${id}/participants`,
		}),
		new Tab('surveys', {
			to: { name: 'market-surveys' },
			name: 'Surveys',
			value: `/markets/${id}/surveys`,
		}),
		new Tab('analysispresets', {
			to: { name: 'market-analysispresets' },
			name: 'Analysis Presets',
			value: `/markets/${id}/analysispresets`,
		}),
		new Tab('variances', {
			to: { name: 'market-variances' },
			name: 'Variances Report',
			value: `/markets/${id}/variances`,
		}),
	]
}
